import React from 'react';
import { Check, Minus } from 'lucide-react';

/**
 * Целевой звонок — **три состояния, а не два**.
 *
 * `null` означает «определить не смогли», а не «нецелевой»: роли говорящих
 * известны только там, где запись разделена по каналам, а по меткам
 * диаризации неизвестно, где клиент. Догадка здесь хуже пустоты — по этому
 * полю считают отчёты, поэтому неизвестное показывается прочерком.
 *
 * Мера — секунды чистой речи клиента, а не длина звонка: минута гудков и
 * минута разговора по длине неотличимы.
 *
 * В таблице (`compact`) остаётся только значок: слово «нецелевой» держало
 * колонку шире, чем весит сама отметка. Смысл при этом не теряется —
 * подсказка объясняет и значок, и сам признак, про который спрашивают чаще
 * всего.
 */
export default function EffectiveMark({
  value,
  compact = false,
}: {
  value: boolean | null | undefined;
  compact?: boolean;
}) {
  if (value === null || value === undefined) {
    return (
      <span
        className="text-xs text-slate-300"
        title="Определить не смогли: роли говорящих известны только при разделении записи по каналам. Это не «нецелевой»"
      >
        —
      </span>
    );
  }

  const title = value
    ? 'Целевой: клиент говорил достаточно. Мера — секунды его чистой речи, а не длина звонка'
    : 'Нецелевой: клиент почти не говорил. Мера — секунды его чистой речи, а не длина звонка';

  if (compact) {
    /* Подсказка на обёртке, а не внутри svg: <title> в иконке читают
       не все браузеры, а объяснение здесь и есть половина смысла. */
    return (
      <span className="inline-flex" title={title} aria-label={value ? 'Целевой' : 'Нецелевой'}>
        {value ? (
          <Check size={14} className="text-green-600" />
        ) : (
          <Minus size={14} className="text-slate-300" />
        )}
      </span>
    );
  }

  return value ? (
    <span className="inline-flex items-center gap-1 text-[11px] text-green-700" title={title}>
      <Check size={11} /> целевой
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 text-[11px] text-slate-500" title={title}>
      <Minus size={11} /> нецелевой
    </span>
  );
}
